import { HugeiconsIcon } from '@hugeicons/react'
import { Building03Icon, InformationCircleIcon, Moon02Icon, Sun03Icon } from '@hugeicons/core-free-icons'

import { useAppStore } from '@/store'
import { cn } from '@/lib/utils'
import { WeatherPill } from './WeatherPill'

// Diriyah's header, built on Tower's chrome vocabulary (glass-pill,
// rounded-control, the oklch tokens) rather than lifted from it: Tower's own
// Header carries currency, language, ambient audio and a buyer/developer
// switcher, none of which this project has.
export function Header() {
  const theme = useAppStore((s) => s.theme)
  const setTheme = useAppStore((s) => s.setTheme)
  const tool = useAppStore((s) => s.tool)
  const toggleTool = useAppStore((s) => s.toggleTool)
  const walking = useAppStore((s) => s.walking)

  // Walking is a takeover: the chrome would sit between the visitor and the
  // thing they are walking through.
  if (walking) return null

  return (
    <header className="pointer-events-none fixed inset-x-0 top-0 z-100 flex items-start gap-2 p-4 sm:p-6">
      <div className="flex min-w-0 flex-1 flex-col items-start gap-3">
        <img src="/logo.svg" alt="Augmento" className="pointer-events-auto h-6 w-auto" />
        <button
          type="button"
          onClick={() => toggleTool('info')}
          aria-pressed={tool === 'info'}
          className="glass-pill pointer-events-auto flex cursor-pointer items-center gap-2 px-3.5 py-2 text-sm font-medium"
        >
          <HugeiconsIcon icon={Building03Icon} size={15} strokeWidth={2} />
          Diriyah Showcase
          <HugeiconsIcon
            icon={InformationCircleIcon}
            size={14}
            strokeWidth={2}
            className="text-foreground/50"
          />
        </button>
      </div>

      <div className="glass-pill pointer-events-auto relative flex shrink-0 items-center gap-1 p-1">
        <WeatherPill />
        <span className="bg-foreground/10 h-5 w-px" aria-hidden />
        <button
          type="button"
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
          className={cn(
            'rounded-control flex size-8 cursor-pointer items-center justify-center transition-colors',
            'text-foreground/60 hover:text-foreground hover:bg-foreground/5',
          )}
        >
          <HugeiconsIcon icon={theme === 'dark' ? Moon02Icon : Sun03Icon} size={16} strokeWidth={2} />
        </button>
      </div>
    </header>
  )
}
